import { OpenAPI } from '@acme/api/shared';
import type { ErrorRoutes } from '@acme/domains';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const DEFAULT_ERROR_ROUTES: ErrorRoutes = {
  401: '/error/401',
  403: '/error/403',
  500: '/error/500',
};

interface ApiErrorHandlerProviderProps {
  children: React.ReactNode;
  routes?: ErrorRoutes;
}

export const ApiErrorHandlerProvider = ({
  children,
  routes = DEFAULT_ERROR_ROUTES,
}: ApiErrorHandlerProviderProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    OpenAPI.ERROR_ROUTES = routes;
    OpenAPI.ON_ERROR = (errorCode: number) => {
      const route = routes[errorCode as keyof ErrorRoutes];
      if (route) {
        navigate(route, { replace: true });
      }
    };
  }, [routes, navigate]);

  return <>{children}</>;
};
